import Reveal from "../components/Reveal";
import classes from "./PageShell.module.css";

const FlightsCollectorPrivacy = () => {
  return (
    <main className={classes.page}>
      <Reveal as="section" className={classes.card}>
        <p className={classes.eyebrow}>Privacy</p>
        <h1>Privacy Policy for Flights Collector</h1>
        <div className={classes.content}>
          <p>Last updated: June 22, 2026</p>

          <p>
            Flights Collector is designed to keep your travel memories private.
            The app does not track you, does not show ads, and does not sell
            your data.
          </p>

          <h2>Information You Add to the App</h2>
          <p>
            Flights Collector lets you save flight ticket details, including
            information such as airline, flight number, airports, dates,
            boarding time, seat, gate, terminal, passenger name, confirmation
            code, notes, ticket photos, memory photos, Live Photos, profile
            nickname, and profile photo.
          </p>
          <p>
            This information is stored on your device. If you choose to use
            iCloud backup, a backup copy is saved to your own iCloud Drive using
            Apple's iCloud services.
          </p>

          <h2>Photos, Camera, and OCR</h2>
          <p>
            Flights Collector may ask for access to your camera or photo library
            so you can scan boarding passes, choose ticket photos, add memory
            photos, or save photos back to your library.
          </p>
          <p>
            Text recognition for ticket scanning is performed on your device
            using Apple's built-in Vision technology. Ticket images are not sent
            to our servers for OCR.
          </p>

          <h2>Wallet Pass Import</h2>
          <p>
            If you import or share an Apple Wallet pass into Flights Collector,
            the app reads the pass file to extract flight details. This
            processing happens on your device.
          </p>

          <h2>iCloud Backup</h2>
          <p>
            iCloud backup is optional. When you use it, Flights Collector saves
            your flight tickets, profile nickname, profile photo, notes, and
            related images to your iCloud Drive. This data is handled by Apple
            under Apple's privacy practices and your iCloud settings.
          </p>

          <h2>Invite and Traveler Sharing</h2>
          <p>
            Flights Collector includes an invite feature that lets you share a
            flight with other travelers. When you use this feature, limited
            information may be sent to our invite service, including flight
            number, origin, destination, flight date, nickname, profile
            identifier, and a small avatar image if you have one.
          </p>
          <p>
            Invite codes are short-lived. This information is used only to
            create and manage the shared traveler experience.
          </p>

          <h2>Purchases</h2>
          <p>
            Flights Collector may offer optional in-app purchases through
            Apple's App Store. Purchase processing is handled by Apple. We do
            not receive or store your payment card information.
          </p>

          <h2>Analytics, Advertising, and Tracking</h2>
          <p>
            Flights Collector does not use third-party advertising SDKs, does
            not track you across apps or websites, and does not collect
            analytics data for advertising.
          </p>

          <h2>Third-Party Services</h2>
          <p>Flights Collector may use:</p>
          <ul>
            <li>
              Apple services, including iCloud, Photos, Camera, Vision, Wallet
              import, and StoreKit
            </li>
            <li>
              Cloudflare infrastructure for the invite and traveler sharing
              feature
            </li>
          </ul>
          <p>
            These services may process limited technical information, such as IP
            address or request metadata, as necessary to provide their services.
          </p>

          <h2>Data Sharing</h2>
          <p>
            We do not sell your personal information. We do not share your saved
            flight collection with advertisers or data brokers.
          </p>
          <p>
            Data is shared only when necessary to provide features you choose to
            use, such as iCloud backup, App Store purchases, or invite sharing.
          </p>

          <h2>Data Deletion</h2>
          <p>
            You can delete flight tickets, photos, notes, and profile
            information in the app. You can also remove the app from your device
            to delete locally stored app data. iCloud backups can be managed
            through your iCloud Drive and Apple account settings.
          </p>

          <h2>Children's Privacy</h2>
          <p>
            Flights Collector is not intended to collect personal information
            from children under 13.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated "Last updated" date.
          </p>

          <h2>Contact</h2>
          <p>
            If you have questions about this Privacy Policy, contact:{" "}
            <a href="mailto:achenloveworks@gmail.com">
              achenloveworks@gmail.com
            </a>
          </p>
        </div>
      </Reveal>
    </main>
  );
};

export default FlightsCollectorPrivacy;
